export const menuOverlayResizer = () => {
  const headerWrapper = document.querySelector('.js-header') as HTMLElement

  if (!headerWrapper) {
    return
  }

  const setResizer = () => {
    const newSize = (window.innerHeight >= window.innerWidth) ? window.innerHeight : window.innerWidth

    headerWrapper.style.setProperty('--overlayScaling', `${newSize * 2.8}`)
  }

  window.addEventListener('resize', () => {
    setResizer()
  })

  setResizer()
}
